module.exports = __webpack_public_path__ + "img/img2.901c0790.jpg";